import React from "react";
import Table from "../../Common/Table";
import icons from "../../../assets/images/constantIcons";
import { Link } from "react-router-dom";
import useAddRunningBooking from "./useAddRunningBooking";

const RunningBooking = () => {
  const { columns, data} = useAddRunningBooking(); // Get columns and data from the hook

  return (
    <div className="">
      <div className="flex justify-between items-start mb-2 md:mb-0 ">
        <h1 className="text-heading text-lg xl:text-xl font-semibold mb-3 lg:mb-2">Running booking</h1>
        <Link to="/mainDashboard/booking">
        <button className="cta !text-green font-bold rounded-full flex items-center">
        <p className="text-xs">View All</p> 
          <icons.FaArrowRightLong className="ml-2" />
        </button>
        </Link>
      </div>
      <div className="overflow-x-auto overflow-y-auto h-[400px] horizontalscroll vertical">
        <Table columns={columns} data={data} />
      </div>
    </div>
  );
};

export default RunningBooking;
